export enum CameraSquareActions {
  addPhoto = 'ADD_PHOTO',
  deletePhoto = 'DELETE_PHOTO',
}
